import React from 'react';

export default function SupportPlaceholderPage({ title, description }) {
  return (
    <div className="support-placeholder-page">
      <div className="smgmt-page-head">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="smgmt-card">
        <p className="smgmt-muted" style={{ margin: 0 }}>
          This section is ready for your live chat queue, knowledge articles, or analytics charts.
          Hook up GraphQL or REST endpoints when your backend is available.
        </p>
      </div>
    </div>
  );
}
